<template>
  <BackofficeLayout :title="$t('message.adminPage.listApp')" :loading="loading">
    <div class="wrapper">
      <div class="main">
        <v-sheet elevation="0" class="radius-10px">
          <div class="form-row form-row-gap--xl">
            <div class="form-row form-row-gap--sm mb-0">
              <v-text-field
                v-model="keyword"
                outlined
                :placeholder="$t('message.adminPage.searchBy')"
                prepend-inner-icon="mdi-magnify"
                required
                dense
                hide-details
                style="width: 410px"
              ></v-text-field>
              <v-btn
                v-if="keyword.length > 0"
                color="primary"
                outlined
                width="90"
                @click="search"
              >
                {{ $t("message.adminPage.search") }}
              </v-btn>
              <v-btn v-else color="gray" outlined width="90" @click="search">
                {{ $t("message.adminPage.search") }}
              </v-btn>
            </div>
            <div class="form__item">
              <v-select
                v-model="selectedFormStatus"
                @change="changeFormStatus"
                outlined
                :items="formStatus"
                :item-text="`label_${$i18n.locale}`"
                item-value="value"
                style="width: 240px"
                prepend-inner-icon="mdi-filter-variant"
                hide-details
                dense
              ></v-select>
            </div>
          </div>
        </v-sheet>

        <v-sheet rounded elevation="1" class="radius-10px">
          <v-data-table
            class="custom-data-table"
            @update:items-per-page="handleChangePageSize"
            @update:page="handleChangePage"
            :headers="headers"
            :items="registrationForm"
            :page.sync="page"
            :options.sync="options"
            :server-items-length="total"
            :items-per-page="pageSize"
            :footer-props="{
              'page-text': `${pageSizeText} ${$t(
                'message.common.pagination.of'
              )} ${total}`,
              'items-per-page-text': `${$t(
                'message.common.pagination.row_per_page'
              )}:`,
              'items-per-page-options': pageSizeOption,
            }"
            hide-default-header
            :hide-default-footer="registrationForm.length <= 0"
          >
            <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th
                    v-for="item in headers"
                    :key="item.value"
                    class="column"
                    :style="{ width: `${item.width}` }"
                  >
                    <div
                      v-if="item.sortable"
                      class="custom-table-header"
                      @click="handleChangeSort(item.sort)"
                    >
                      {{ item.text }}
                      <template v-if="item.sort === sort">
                        <v-icon v-if="sortDirection === 'desc'" small
                          >mdi-chevron-up</v-icon
                        >
                        <v-icon v-else small>mdi-chevron-down</v-icon>
                      </template>
                      <template v-else>
                        <v-icon small>mdi-unfold-more-horizontal</v-icon>
                      </template>
                    </div>
                    <div v-else>
                      {{ item.text }}
                    </div>
                  </th>
                </tr>
              </thead>
            </template>
            <template v-slot:[`item.form_status`]="{ item }">
              <span style="color: red" v-if="item.form_status === 'DRAFT'">{{
                formStatusText(item.form_status)
              }}</span>
              <span v-else>
                <v-icon
                  v-if="item.form_status === 'ACTIVE'"
                  left
                  class="icon--green"
                  small
                  >mdi-check-circle</v-icon
                >
                {{ formStatusText(item.form_status) }}
              </span>
            </template>
            <template v-slot:[`item.number_of_student`]="{ item }">
              {{ item.number_of_student ?? 0 }}
            </template>
            <template v-slot:[`item.date`]="{ item }">
              {{ formatDateTime(item.opening_date) }} -
              {{ formatDateTime(item.closing_date) }}
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <div class="custom-table-action">
                <a>
                  <v-icon
                    :class="!item.number_of_student ? 'icon--disabled' : ''" small
                    @click.prevent="downloadPdf(item)">mdi-download
                  </v-icon>
                </a>
                <router-link
                  class="icon--link"
                  :to="`/registration/calendar/${item.id}`"
                  ><v-icon small>mdi-eye</v-icon></router-link
                >
                <a v-if="enabledDelete(item.form_status)"
                  ><v-icon small @click="openDeleteConfirmationModal(item)"
                    >mdi-delete</v-icon
                  ></a
                >
                <a v-else
                  ><v-icon class="icon--disabled" small>mdi-delete</v-icon></a
                >
              </div>
            </template>
            <template v-slot:no-data>
              <div class="custom-data-table-empty-data">
                <div>
                  <v-icon class="mb-2" large>mdi-plus-box</v-icon>
                  <p>
                    {{
                      $t(
                        "message.registration_form.empty_list_of_application_form"
                      )
                    }}
                  </p>
                </div>
              </div>
            </template>
          </v-data-table>
          <VueHtml2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="false"
            :manual-pagination="true"
            :pdf-quality="2"
            pdf-content-width="100%"
            :html-to-pdf-options="pdfOption"
            ref="html2pdf"
          >
            <section slot="pdf-content">
              <ApplicationPart
                v-if="registrationFormDetail && organizationDetail"
                :registrationFormDetail="registrationFormDetail"
                :organizationDetail="organizationDetail"
                :studentDataList="studentDataList"
                :reportTitle="reportTitle"
              />
            </section>
          </VueHtml2pdf>
        </v-sheet>
      </div>
    </div>
    <v-dialog v-model="isShowDeleteConfirmationModal" width="450">
      <div class="modal__content">
        <v-icon
          class="modal__icon modal__close-button"
          @click="closeDeleteConfirmationModal"
          >mdi-close</v-icon
        >
        <v-icon class="modal__icon modal__icon__red">mdi-alert-circle</v-icon>
        <p class="modal__title">
          {{ $t("message.registration_form.remove_list_of_applicants") }} ?
        </p>
        <p class="modal__description" v-if="selectedRegistrationForm">
          {{
            $t(
              "message.registration_form.remove_list_of_application_description",
              {
                name: selectedRegistrationForm.register_name,
                total: selectedRegistrationForm.number_of_student ?? 0,
              }
            )
          }}
        </p>
        <div class="modal__action">
          <v-btn
            color="primary"
            outlined
            rounded
            elevation="0"
            width="180"
            :loading="isSubmitting"
            @click="closeDeleteConfirmationModal"
          >
            {{ $t("message.common.cancel") }}
          </v-btn>
          <v-btn
            color="error"
            rounded
            elevation="0"
            width="180"
            @click="remove"
            :loading="isSubmitting"
          >
            {{ $t("message.common.confirm") }}
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </BackofficeLayout>
</template>

<script>
import BackofficeLayout from "@/components/common/BackofficeLayout";
import * as services from "@/services";
import * as dateUtils from "@/utils/date";
import { calculateCurrentPage } from "@/utils/pagination";
import {
  FORM_STATUS_CALENDAR_OPTION,
  PAGE_SIZE_OPTIONS,
  OPPOSITE_SORT,
  DEFAULT_PAGE_SIZE,
} from "@/constants";
import router from "@/router";
import i18n from "@/i18n";
import VueHtml2pdf from "vue-html2pdf";
import ApplicationPart from "@/components/fileElement/ApplicantPart.vue";

const DEFAULT_SORT_KEY = "register_form_config.semester_year";
const DEFAULT_SORT_DIRECTION = "DESC";

export default {
  name: "RegistrationForm",
  components: {
    BackofficeLayout,
    VueHtml2pdf,
    ApplicationPart
  },
  data() {
    return {
      formStatus: FORM_STATUS_CALENDAR_OPTION,
      selectedFormStatus: "",
      keyword: "",
      registrationForm: [],
      selectedRegistrationForm: null,
      isShowDeleteConfirmationModal: false,
      options: {}, // v-data-table
      pages: 1,
      page: 1,
      pageSize: DEFAULT_PAGE_SIZE,
      total: 0,
      sort: DEFAULT_SORT_KEY,
      sortDirection: DEFAULT_SORT_DIRECTION,
      pageSizeOption: PAGE_SIZE_OPTIONS,
      loading: 0,
      isSubmitting: false,
      registrationFormDetail: {},
      organizationDetail: null,
      studentDataList: [],
      reportTitle: null,
    };
  },
  computed: {
    pdfOption() {
      return {
        margin: 0,
        image: { type: "jpeg", quality: 0.98 },
        filename: "applicant_report.pdf",
        pagebreak: { mode: 'avoid-all', before: '.before', after: '.after', avoid: '.avoid' },
        html2canvas: { scale: 2, dpi: 900, letterRendering: true, useCORS: true },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait", compress: false },
      }
    },
    pageSizeText() {
      return calculateCurrentPage(this.page, this.pageSize, this.total);
    },
    headers() {
      return [
        {
          text: i18n.t("message.adminPage.accademicYear"),
          value: "semester_year",
          sort: "register_form_config.semester_year",
          sortable: true,
          width: "15%",
        },
        {
          text: i18n.t("message.adminPage.applicationTitle"),
          value: "register_name",
          sort: "register_form_config.register_name",
          sortable: true,
          width: "15%",
        },
        {
          text: i18n.t("message.adminPage.requiredAmount"),
          value: "total_student",
          width: "15%",
          sort: "register_plan.total_student",
          sortable: true,
        },
        {
          text: i18n.t("message.adminPage.candidateAmount"),
          value: "number_of_student",
          width: "15%",
          sort: "register_student.number_of_student",
          sortable: true,
        },
        {
          text: i18n.t("message.adminPage.applicationPeriod"),
          value: "date",
          width: "20%",
          sort: "register_form_config.opening_date",
          sortable: true,
        },
        {
          text: i18n.t("message.adminPage.status.status"),
          value: "form_status",
          sort: "register_form_config.form_status",
          sortable: true,
          width: "15%",
        },
        { text: "", value: "action", width: "5%" },
      ];
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async getRegistrationForm() {
      try {
        this.loading++;
        const query = this.prepareQuery();
        const {
          data: { data },
        } = await services.getRegistrationCalendar(query);
        this.registrationForm = data.registration_form;
        this.pages = data.total_page;
        this.total = data.total;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading--;
      }
    },
    async remove() {
      try {
        this.isSubmitting = true;
        const id = this.selectedRegistrationForm.id;
        await services.deleteRegistrationStudent(id);
      } catch (error) {
        console.log(error);
      } finally {
        this.closeDeleteConfirmationModal();
        this.isSubmitting = false;
      }
    },
    search() {
      router.push({
        path: "/registration/calendar",
        query: { ...this.query, keyword: this.keyword },
      });
    },
    handleChangePage(newPage) {
      const query = this.prepareQuery();
      const path = this.$route.path;
      router.push({
        path,
        query: { ...query, page: newPage },
      });
    },
    handleChangePageSize(newPageSize) {
      const query = this.prepareQuery();
      const path = this.$route.path;
      router.push({
        path,
        query: { ...query, page_size: newPageSize },
      });
    },
    changeFormStatus(value) {
      router.push({
        path: "/registration/calendar",
        query: { ...this.query, status: value },
      });
    },
    formatDateTime(date) {
      return dateUtils.formatDateTime(date, this.$i18n.locale);
    },
    countNumberOfStudent(plan) {
      return plan
        .map((item) => item.total_students)
        .reduce((previous, current) => previous + current, 0);
    },
    formStatusText(status) {

      return FORM_STATUS_CALENDAR_OPTION.find((item) => item.value == status)[`label_${this.$i18n.locale}`];
    },
    init() {
      const query = this.$route.query;
      const keyword = query.keyword || "";
      const status = query.status || "";
      const page = query.page ? parseInt(query.page) : 1;
      const pageSize = query.page_size
        ? parseInt(query.page_size)
        : DEFAULT_PAGE_SIZE;
      const sort = query.sort ? query.sort.split(":") : "";
      const sortKey = sort?.[0] ?? DEFAULT_SORT_KEY;
      const sortDirection = sort?.[1] ?? DEFAULT_SORT_DIRECTION;
      this.keyword = keyword;
      this.selectedFormStatus = status;
      this.page = page;
      this.pageSize = pageSize;
      this.sort = sortKey;
      this.sortDirection = sortDirection;
      this.options.itemsPerPage = this.pageSize;
      this.getRegistrationForm();
    },
    handleChangeSort(key) {
      let direction = "desc";
      if (key === this.sort) {
        direction = OPPOSITE_SORT[this.sortDirection] || "desc";
      }
      const sort = `${key}:${direction}`;
      const path = this.$route.path;
      const query = this.prepareQuery();
      router.push({
        path,
        query: { ...query, sort },
      });
    },
    prepareQuery() {
      return {
        keyword: this.keyword,
        status: this.selectedFormStatus,
        page: this.page,
        page_size: this.pageSize,
        sort: `${this.sort}:${this.sortDirection}`,
      };
    },
    openDeleteConfirmationModal(data) {
      this.selectedRegistrationForm = data;
      this.isShowDeleteConfirmationModal = true;
    },
    closeDeleteConfirmationModal() {
      this.selectedRegistrationForm = null;
      this.isShowDeleteConfirmationModal = false;
    },
    enabledDelete(status) {
      if (["ON_PROCESS_TRANSFER", "SUCCESSFUL_TRANSFER"].includes(status)) {
        return true;
      }
      return false;
    },
    async downloadPdf({id}) {
      try {
        this.loading++;
        const { data: { data: { organization }}} = await services.getOrganization();
        this.organizationDetail = organization;

        const { data: { data: { registration_form, students }}} = await services.getRegistrationDownloadById(id);
        this.registrationFormDetail = registration_form
        this.studentDataList = students

        this.reportTitle = `${this.$t('message.common.applicantReport.title')}`;
        this.$nextTick(() => {
          this.$refs.html2pdf.generatePdf();
        });
      } catch (error) {
        console.error('Error downloading PDF:', error)
        this.$toast.error(this.$t('message.common.downloadError'));
      } finally {
        this.loading--;
      }
    },
},
  watch: {
    $route() {
      this.init();
    },
  },
};
</script>

<style scoped>
.wrapper {
  padding: 0 24px 24px 24px;
}

.main {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 24px;
  border-top: 1px solid #d7d6d8;
}

.form--inline {
  display: flex;
}

.form--gap-xl {
  gap: 32px;
}

.form--gap-md {
  gap: 16px;
}

.form__item--full {
  flex: 1;
}
.form__item--right {
  text-align: right;
}

.radius-10px {
  border-radius: 10px !important;
}
</style>
